import React from "react";
import {
    Box,
    Text,
    VStack,
    HStack,
    Icon,
    Flex,
    Collapse,
    useDisclosure,
} from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import * as FiIcons from "react-icons/fi";

interface CustomAppointmentSelectorProps {
    appointmentGroups: {
        appointment_group_id: string;
        name: string;
        price: string;
        icon: string;
    }[];
    selectedAppointmentGroupId: string;
    handleAppointmentGroupChange: (appointment_group_id: string) => void;
}

const CustomAppointmentSelector: React.FC<CustomAppointmentSelectorProps> = ({
    appointmentGroups,
    selectedAppointmentGroupId,
    handleAppointmentGroupChange,
}) => {
    const { isOpen, onToggle } = useDisclosure();

    const selected = appointmentGroups.find(
        (g) => g.appointment_group_id === selectedAppointmentGroupId
    ) || appointmentGroups[0];

    const getIconComponent = (iconName: string) => {
        return (FiIcons as any)[iconName] || FiIcons.FiUser;
    };

    return (
        <Box w="100%" border="1px solid #CBD5E0" borderRadius="md" overflow="hidden">
            <Box
                p={4}
                borderBottom="1px solid #E2E8F0"
                onClick={onToggle}
                cursor="pointer"
                _hover={{ bg: "gray.50" }}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
            >
                <Text fontWeight="medium">{selected.name}</Text>
                <Box display={'flex'} flexDirection={"row"}>
                    <Text fontWeight="bold" mr={5}>{selected.price}</Text>
                    {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                </Box>
            </Box>

            <Collapse in={isOpen}>
                <VStack spacing={0} align="stretch">
                    {appointmentGroups.map((group) => {
                        const isSelected = selectedAppointmentGroupId === group.appointment_group_id;
                        const IconComponent = getIconComponent(group.icon);

                        return (
                            <Flex
                                key={group.appointment_group_id}
                                p={4}
                                bg={isSelected ? "gray.100" : "white"}
                                align="center"
                                justify="space-between"
                                borderBottom="1px solid #EDF2F7"
                                cursor="pointer"
                                _hover={{ bg: "gray.50" }}
                                onClick={() => {
                                    handleAppointmentGroupChange(group.appointment_group_id);
                                    onToggle();
                                }}
                            >
                                <HStack spacing={4}>
                                    <Box
                                        p={2}
                                        bg="#21342F"
                                        color={'#fff'}
                                        borderRadius="md"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Icon as={IconComponent} boxSize={5} />
                                    </Box>
                                    <Text fontSize="sm">{group.name}</Text>
                                </HStack>
                                <HStack spacing={4}>
                                   
                                    <Text fontWeight="bold">{group.price}</Text>
                                </HStack>
                            </Flex>
                        );
                    })}
                </VStack>
            </Collapse>
        </Box>
    );
};

export default CustomAppointmentSelector;
